import type { Rate } from '@nxsys/types/models/invoice';

/** A VAT total can name a rate only when every taxable line uses that rate. */
export const vatTotalLabel = (rates?: Pick<Rate, 'vatRate' | 'raiseInvoice'>[]) => {
  const taxableRates = new Set(
    (rates ?? [])
      .filter((rate) => rate.raiseInvoice !== false)
      .map((rate) => Number.parseFloat(rate.vatRate))
      .filter((rate) => Number.isFinite(rate) && rate > 0),
  );
  return taxableRates.size === 1
    ? `Total VAT ${[...taxableRates][0]}%`
    : 'Total VAT';
};
